import React from 'react';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import SectionsInfo from '../SectionsInfo';
import ServiceCard from './ServiceCard';
import removeHtmlTags from '../../helpers/removeHtmlTags';

function OurServices({ data }) {
  const lang = Cookies.get('i18next') || 'en';
  const { translations } = useSelector((state) => state.translation);
  return (
    <div className="our_services">
      <div className="container small">
        <div className="our_services__content">
          <SectionsInfo
            title={data.our_services_title[lang]}
            description={data.our_services_content_title[lang]}
          />
          <div className="our_services__cards">
            {data?.data.published_sections?.map((e) => (
              <ServiceCard
                link={e.url[lang]}
                btnText={translations.more_details[lang]}
                decription={removeHtmlTags(e.body[lang])}
                imgAlt={e.image.alt_attribute[lang]}
                image={e.image.webp_url}
                title={e.title[lang]}
                key={e.id}
              />
            ))}
          </div>
        </div>
      </div>
    </div>

  );
}

export default OurServices;
